import { BARCODE_TYPES } from 'library/constants/models/item';

const ATTRIBUTES_KEYS = {
  category: 'category',
  set: 'set',
  colors: 'colors',
  count: 'count',
  tags: 'tags',
  drawer: 'drawer',
  manufacturer: 'manufacturer',
  barcode: 'barcode',
  price: 'price',
  notes: 'notes',
};

const ATTRIBUTES_ICONS = {
  category: 'category',
  set: 'set',
  colors: 'colors',
  count: 'layers',
  tags: 'tags',
  drawer: 'drawer',
  manufacturer: 'manufacturer',
  barcode: 'barcode',
  price: 'price',
  notes: 'notes',
};

const ACTIONS = [
  {
    name: 'like',
    title: 'Like',
  }, {
    name: 'heart',
    title: 'Add to wishlist',
  }, {
    name: 'pencil',
    title: 'Edit item',
  }, {
    name: 'set',
    title: 'Add to a set',
  }, {
    name: 'projects',
    title: 'Add to a project',
  }, {
    name: 'trash',
    title: 'Remove item',
  },
];

export const BARCODE_TYPES_OPTIONS = [
  { text: 'EAN', value: BARCODE_TYPES.EAN },
  { text: 'UPC', value: BARCODE_TYPES.UPC },
];

export { ATTRIBUTES_KEYS, ATTRIBUTES_ICONS, ACTIONS };
